//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, setTitle, consoleLog} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
//import './components/fontawesome/fontawesome';
import CopyBox from './components/bbcode/copybox';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Button from 'react-bootstrap/Button';

//import './css/index.css';
//import './css/header.css';

export default class PortalStreamKey extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: 0,
			//services: [],
			servers: [],
			address: 'cloud.ultrastream.io',
			key: ''
		};
		this.serverSelect = this.serverSelect.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});

		let params = new URLSearchParams();
		const x = await postApi('/v3/portal/streamkey', params);
		//consoleLog(x.status, x.data);
		setTitle('Stream Key');
		
		if( x.status === 200 ) {
			this.setState({status: 2, servers: x.data.servers?x.data.servers:[], key: x.data.key?x.data.key:''});
		} else {
			this.setState({status: 1});
		}
		

		/*
		let params = new URLSearchParams();
		const x = await postApi('/v3/index', params);
		
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});
		*/

	}

	componentWillUnmount() {
	}


	async serverSelect(address) {
		this.setState({address});
	}
	

	render() {

		/*const services = Object.keys(this.state.services).map((e,i) => {
			return (
				<Col xxl={6} xl={12} lg={12} md={6} sm={12} key={i}>
					<div className="card custom-card product-card">
						<div className="card-body">
							<div className="d-sm-flex align-items-center">
								<a href="product-details.html" className="product-image-1">
									<img src="../assets/images/ecommerce/png/1.png" className="card-img" alt="..." />
								</a>
								<div className="ms-3 mt-2 mt-sm-0">
									<h5 className="product-name fs-16 fw-semibold mb-0 align-items-center">{this.state.services[e].title}</h5>
									<p className="product-description fs-13 text-muted mb-0">{this.state.services[e].description&&this.state.services[e].description.substring(0,100)}</p>
									<h4 className="mb-1 fw-semibold">
										<span>Live: <span className="text-muted ms-1  fs-14 op-6">DJ Random 1</span></span>
									</h4>
									<p className="badge bg-secondary-transparent fs-11 rounded-1 mb-0">72% off</p>
									<span className="badge bg-warning-transparent rounded-1">4.2 <i className="ri-star-s-fill align-middle  d-inline-block"></i> </span>
									<span className="text-muted">(12,456)</span>
									<p className="fs-11 text-success fw-semibold mb-0 align-items-center"> Free Delivery </p>
									<div className="mt-2">
										<a href="wishlist.html" className="btn btn-sm btn-danger-light me-1"><i className="ri-heart-line"></i></a>
										<a href="cart.html" className="btn btn-sm btn-info-light me-1"><i className="ri-shopping-cart-line"></i></a>
										<a href="product-details.html" className="btn btn-sm btn-success-light"><i className="ri-eye-line"></i></a>
									</div>
								</div>
							</div>
						</div> 
					</div>
				</Col>
			)
		});*/

		const servers = this.state.servers.map((e,i) => {
			return (
				<option key={i} onClick={()=>this.serverSelect(e.subdomain)}>
					{e.location} - rtmp://{e.subdomain}/live
				</option>
			)
		})
		
		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Dashboard</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								{/*<li className="breadcrumb-item"><a href="javascript:void(0);">Ui Elements</a></li>*/}
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status > 0 &&
					<div className="main-content app-content">
						<div className="container-fluid">
							<Row>
								<Col xs={12}>
									<div className="card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Stream Key</span>
													<p className="fs-13 text-muted mb-0">Stream key settings for live streaming and testing</p>
												</div>
											</div>
										</div>
									</div>
								</Col>
							</Row>
							{this.state.status === 1 &&
								<Row className="pt-3">
									<Col xl={12}>
										<div className="card custom-card">
											<div className="card-header justify-content-between">
												<div className="card-title">
													No Active Services
												</div>
											</div>
											<div className="card-body">
												<div className="">
													<p>Unfortunately you do not have any current active services and you'll neen to have at least one active service to use this service</p>
													<p>You can head to our home page to order services <a href="https://ultrastream.io">https://ultrastream.io</a></p>
												</div>
											</div>
										</div>
									</Col>
								</Row>
							}
							{this.state.status === 2 &&
								<Row className="pt-3">
									<Col xl={12}>
										<div className="card custom-card">
											<div className="card-header justify-content-between">
												<div className="card-title">
													Live Stream
												</div>
											</div>
											<div className="card-body">
												<div className="">
													<p>Server Choice</p>
													<p>
														<select className="form-control">
															<option onClick={()=>this.serverSelect('cloud.ultrastream.io')}>Default CDN Server - rtmp://cloud.ultrastream.io/live</option>
															{servers}
														</select>
													</p>
													<p>Server Address:</p>
													<CopyBox content={`rtmp://${this.state.address}/live`} />
													<p>Stream Key:</p>
													<CopyBox content={this.state.key} />
												</div>
											</div>
										</div>
									</Col>
								</Row>
							}
						</div>
					</div>
				}
				{/*this.state.status === 2 &&
					<div className="main-content app-content">
						 
						<div className="container-fluid">

							<div className="my-4">
								<Row>
									<Col xl={12}>
										<div className="card custom-card">
											<div className="card-body p-0">
												<div className="navbar navbar-expand-xxl bg-white">
													<a className="navbar-brand" href="javascript:void(0);">
														<img src="../assets/images/brand-logos/toggle-logo.png" alt="" className="d-inline-block align-text-top" />
													</a>
													<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
														<span className="navbar-toggler-icon"></span>
													</button>
													<div className="collapse navbar-collapse navbar-justified" id="navbarSupportedContent">
														<ul className="navbar-nav me-auto mb-2 mb-lg-0 align-items-xxl-center">
															<li className="nav-item">
																<a className="nav-link active" aria-current="page" href="javascript:void(0);">Pending (0)</a>
															</li>
															<li className="nav-item">
																<a className="nav-link" href="javascript:void(0);">Active (0)</a>
															</li>
															<li className="nav-item dropdown">
																<a className="nav-link" href="javascript:void(0);">Cancelled (0)</a>
															</li>
														</ul>
													</div> 
												</div>
											</div>
										</div>
									</Col>
									
									
								</Row>
							</div>

							

							
						</div>
					</div>
				*/}
			</>
		);
	}
}
